import { IExercise } from '../../../core/models/exercise';
import { iOption } from '../../../core/components/atoms/Select';

export const organizeExerciseField = (exercise: IExercise) => {
  if (exercise.alternatives) {
    exercise.alternatives = exercise.alternatives.map((alternative) => {
      alternative.id = alternative._id;
      return alternative;
    });

    exercise.exerciseType = exercise.exercise_type;
  }

  return exercise;
};

export const listExercisesYear = () => {
  const currentYear = new Date().getFullYear();
  const yearOptions: iOption[] = [
    { value: 'all', label: 'Todos os anos' },
    ...Array.from(
      { length: currentYear - 1992 + 1 },
      (_, i) => {
        const year = currentYear - i;
        return {
          value: year,
          label: year.toString()
        };
      }
    )
  ];
  return yearOptions;
}